import Global from '../scripts/Global'
import TextareaManager from './Textarea.manager';
import DOMManager from './DOM.manager';
import { CPUtils } from '../scripts/Utils';
import config from '../scripts/config';
import VueSignals from '../scripts/VueSignals';
import SessionManager from './Session.manager';

let SpecialKeys = ["Enter", "Escape"]
let MentionKeys = ["ArrowUp", "ArrowDown","Enter", "Tab", "Escape"]
let inputArea =  ''
let chatmode = true
let new_line = false
let TrackCursor = null
let isListOpen = false
let EnterDown = false
let EnterDownCounter = 0
let edit_area = false
let ListOpenEnterCounter = 0
let ArrowDowncounter = 0

/**
 * Note:
 *  differentiate between the input listeners and window listeners
 */

export default class KeyboardManager {
    constructor(){}
    static init(inputArea = null){
        // if(inputArea == null){
        //     inputArea =  document.querySelector('[contenteditable]')
        // }

        if(inputArea == null){
            inputArea = document.getElementById(config.DEFAULT_MESSAGE_AREA_ID)
        }

        try {
            TextareaManager.init(inputArea)
            DOMManager.init(inputArea)
            // for Chrome and safari detection
            inputArea.addEventListener('input', function(e){
                //  document.execCommand("defaultParagraphSeparator", true, " ")
                if(inputArea.childNodes.length == 0 ||
                    inputArea.firstChild.nodeName == "#text" ||
                    inputArea.firstChild.nodeName == "BR"){
                        let pargraph = document.createElement("p")
                        inputArea.innerHTML = ""
                        inputArea.appendChild(pargraph)
                        TextareaManager.MoveCursorAfterAdd(0)
                        DOMManager.RestartCursor()
                    }
                    DOMManager.TrackCursor()

                    // DOMManager.replaceNewLine(e, EnterDownCounter)              /// replace <br> with new <p>
                    if(this.childNodes.length == 1 && this.childNodes[0].childNodes.length == 0 ){
                        this.classList.add('empty')
                    }else {
                        this.classList.remove('empty')
                    }
                })


                inputArea.addEventListener('keydown', function(e){
                    KeyboardManager.CheckComination(e)
                    if(chatmode && !edit_area){
                        KeyboardManager.MentionDetector(e)
                    }
                })
        } catch (e) {
            console.error("Text area not available");
        }



        window.onmouseup = function(e){
            if(e.button == 2){
                Global.globalValue(VueSignals.MOVE_CONTEXT_MENU, document.querySelector(".selected").offsetTop)
            }
            if((!e.target.classList.contains('fa-ellipsis-h') ) &&
                e.button != 2){
                    Global.globalValue(VueSignals.HIDE_CONTEXT_MENU, true)
            }

            if(!e.target.classList.contains('options-click') &&
                !e.target.parentNode.classList.contains('options-click')){
                    Global.globalValue(VueSignals.HIDE_OPTIONS_MENU, true)
            }

            if(!e.target.classList.contains('generated_list') || !e.target.parentNode.classList.contains('generated_list')){
                Global.globalValue(VueSignals.HIDE_KEYBOARD_GENERATED_LIST, true)
            }

            if(!e.target.parentNode.classList.contains('emoji-mart') ||
               !e.target.parentNode.classList.contains('emoji-mart-search') ||
               !e.target.parentNode.classList.contains('emoji-mart-scroll')){
                Global.globalValue(VueSignals.HIDE_EMOJI_LIST, true)
            }

        }
        window.onkeyup = function(e){
            if(chatmode){
                if(e.code == 'Enter'){
                    EnterDown = false
                    EnterDownCounter = 0
                }

                if(e.key == 'Backspace'){
                    let cursor = DOMManager.getCursor()
                    if(cursor.startContainer.parentNode && cursor.startContainer.parentNode.classList.contains('mention_slag')){
                        cursor.startContainer.parentNode.classList.add('mention_suggest')
                        cursor.startContainer.parentNode.classList.remove('mention_slag')
                        cursor.startContainer.parentNode.title = "was a mention"
                        // cursor.startContainer.parentNode.outerHTML = cursor.startContainer.parentNode.outerHTML
                        //                                              .replace('</span>', '<i class="fas fa-question-circle theme-color"></i></span>')
                        //@refactor
                        // let range = document.createRange()
                        // let sel = window.getSelection()
                        // let MentionPosition =  TextareaManager.getChildPositionByDataID(cursor.startContainer.parentNode.dataset.id)
                        // let text = document.createTextNode("\u00A0 ")
                        // DOMManager.insertAfter(text, MentionPosition.node)
                        // range.setStartAfter(text)
                        // range.collapse(true)
                        // sel.removeAllRanges()
                        // sel.addRange(range)

                        // TODO(ALEX): This one may not be neccesary
                        Global.globalValue("mention_to_delete", cursor.startContainer.parentNode.dataset.id)
                        let matchSearch = cursor.startContainer.textContent;
                        if (cursor.startContainer.textContent.includes('$')) {
                            Global.globalValue("mention_delete_open_list_folder", {id: cursor.startContainer.parentNode.dataset.id, search: matchSearch})
                        } else {
                            // User mention @
                            Global.globalValue("mention_delete_open_list", {id: cursor.startContainer.parentNode.dataset.id, search: matchSearch})
                        }
                    }
                    if(cursor.startContainer.parentNode && cursor.startContainer.parentNode.classList.contains('emoji-icon')){
                        console.log('HERE!');
                    }
                }

                if (e.code == 'Escape' || e.code == 'Enter') {
                  /** Detect first enter to chhose from list and with
                   * seconed start to get back to normal and allow enter to send message  */
                  if (isListOpen) {
                      ListOpenEnterCounter++
                      if (ListOpenEnterCounter == 1) {
                          ListOpenEnterCounter = 0
                          isListOpen = false
                      }
                  }
                }
            }
        }
        window.onkeydown = function(e){
            if(e.code == "NumpadEnter"){ // to ovveride line break because of it
                e.preventDefault()
            }
            // @for allowing copy
            if(e.key == 'c' && (e.ctrlKey || e.metaKey)){
                chatmode = false
            }


            if(chatmode){
                if(e.key == "Enter"){
                    EnterDown = true
                    EnterDownCounter = 0
                }

                if(EnterDown && e.key.length == 1){
                    EnterDownCounter++
                }

                if(e.key.length == 1 && document.activeElement.id != config.DEFAULT_MESSAGE_AREA_ID){
                    TextareaManager.MoveCursorAfterAdd(null)
                }

            }
            TrackCursor = DOMManager.TrackCursor()

            // Close mention list if keyword has been deleted
            if (e.key == 'Backspace') {
                let cursor = DOMManager.getCursor()
                let text = cursor.startContainer.textContent;
                let lastCharDeleted = text.substr(text.length - 1);
                if (lastCharDeleted === '@' || lastCharDeleted == '$') {
                    if (isListOpen) {
                        ListOpenEnterCounter = 0;
                        isListOpen = false;
                        Global.globalValue(VueSignals.HIDE_KEYBOARD_FOLDER_LIST, true);
                        Global.globalValue(VueSignals.HIDE_KEYBOARD_GENERATED_LIST, true);
                    }
                }
            }
        }

        window.onkeypress = function(e){
            if(chatmode && !edit_area){
                KeyboardManager.MentionDetector(e)
            }
        }


        if(inputArea != null){
            inputArea.onmouseup = function(e){
                TrackCursor = DOMManager.TrackCursor()
            }
        }
    }


    /**
     * Returns special instruction key
     */
    static setMentionInstruc() {
      document.querySelector('[contenteditable]').onkeydown = function(e){
          if(isListOpen){
                // TODO: Re-think this, discern between mentions
                Global.globalValue(VueSignals.KEYBOARD_MENTION_USER_TAG_FEED, e)
                Global.globalValue(VueSignals.MENTION_MENTION_TAG_FF_FEED, e)

                if(MentionKeys.includes(e.key)){
                    e.preventDefault()
                    let mention_iterate_list = document.querySelector('.iterate-list')
                    if(document.querySelector('.mention-item.active') != null){
                        let mention_id = document.querySelector('.mention-item.active').id

                        if(mention_iterate_list != null){
                            // TODO: It's the same code in both mention listeners
                            // if(e.key == "Enter"){
                            //     let active_mention_item = document.querySelector('.mention-item.active').innerText.trim()
                            //     let mention_type = document.querySelector('.mention-item.active').dataset.type
                            //     Global.globalValue(VueSignals.KEYBOARD_NAVIGATE_MENTION_ITEM, {
                            //         "mention_item ": active_mention_item,
                            //         "mention_id": mention_id,
                            //         "mention_type": mention_type
                            //     })
                            //     Global.globalValue(VueSignals.KEYBOARD_CHOOSE_MENTION_ITEM, document.querySelector('.mention-item.active').id)
                            // }
                            let max_count = mention_iterate_list.childNodes.length
                            if(e.key == "Tab" || e.key ==  "ArrowDown"){
                                ArrowDowncounter++
                                for(let i=0;i< mention_iterate_list.childNodes.length;i++){
                                    if(typeof mention_iterate_list.childNodes[i].classList != 'undefined'
                                    && mention_iterate_list.childNodes[i].classList.value.indexOf("mention-item") > -1){
                                        if(mention_iterate_list.childNodes[i].classList.value.indexOf("active") > -1){
                                            if(ArrowDowncounter == 1 || max_count == 1){
                                                let active_mention_item = mention_iterate_list.getElementsByTagName('li')[0].textContent.trim()
                                                let mention_type = mention_iterate_list.getElementsByTagName('li')[0].dataset.type
                                                Global.globalValue(VueSignals.KEYBOARD_NAVIGATE_MENTION_ITEM, {
                                                    "mention_item": active_mention_item,
                                                    "mention_id": mention_id,
                                                    "mention_type": mention_type
                                                })
                                                break
                                            }
                                           if(ArrowDowncounter > 1 && max_count > 1) {
                                                mention_iterate_list.getElementsByTagName('li')[0].classList = mention_iterate_list.getElementsByTagName('li')[0].classList.value.replace('active', '')
                                                mention_iterate_list.childNodes[i].classList = mention_iterate_list.childNodes[i].classList.value.replace('active', '')
                                                if(i+1 == max_count){
                                                    let j=0
                                                    while( typeof mention_iterate_list.childNodes[j] != 'undefined'){
                                                        if(mention_iterate_list.childNodes[j].nodeName == "LI"){
                                                            mention_iterate_list.childNodes[j].classList += " "+ 'active'
                                                            let active_mention_item = mention_iterate_list.childNodes[j].textContent.trim()
                                                            let mention_type = mention_iterate_list.childNodes[j].dataset.type
                                                            CPUtils.scroll( document.querySelector(".iterate-list"), mention_iterate_list.childNodes[j].offsetTop)
                                                            Global.globalValue(VueSignals.KEYBOARD_NAVIGATE_MENTION_ITEM, {
                                                                "mention_item": active_mention_item,
                                                                "mention_id": mention_id,
                                                                "mention_type": mention_type
                                                            })
                                                            break
                                                        }
                                                        j++
                                                    }
                                                }else {
                                                    let mention_type = ''
                                                    let active_mention_item = ''
                                                    let j=i+1
                                                    while( typeof mention_iterate_list.childNodes[j] != 'undefined'){
                                                        if(typeof mention_iterate_list.childNodes[j].nodeName  != 'undefined' &&
                                                            mention_iterate_list.childNodes[j].nodeName == "LI"){
                                                            mention_iterate_list.childNodes[j].classList += " "+ 'active'
                                                            active_mention_item = mention_iterate_list.childNodes[j].textContent.trim()
                                                            mention_type = mention_iterate_list.childNodes[j].dataset.type
                                                            if(typeof mention_iterate_list.childNodes[j-2] != 'undefined'){
                                                                CPUtils.scroll( document.querySelector(".iterate-list"), mention_iterate_list.childNodes[j-2].offsetTop)
                                                            }else {
                                                                CPUtils.scroll( document.querySelector(".iterate-list"), mention_iterate_list.childNodes[j-1].offsetTop)
                                                            }
                                                            break
                                                        }
                                                        j++
                                                    }
                                                    Global.globalValue(VueSignals.KEYBOARD_NAVIGATE_MENTION_ITEM,{
                                                        "mention_item": active_mention_item,
                                                        "mention_id": mention_id,
                                                        "mention_type": mention_type
                                                    })
                                                    break
                                                }
                                            }

                                        }
                                    }
                                }
                            }
                            if(e.key == "ArrowUp"){
                                for(let i=0;i < max_count;i++){
                                    if(typeof mention_iterate_list.childNodes[i].classList != 'undefined'
                                    && mention_iterate_list.childNodes[i].classList.value.indexOf("mention-item")>-1){
                                        if(mention_iterate_list.childNodes[i].classList.value.indexOf("active") > -1){
                                            mention_iterate_list.childNodes[i].classList = mention_iterate_list.childNodes[i].classList.value.replace('active', '')
                                            let s = 0 // find position of first LI

                                            while(s < max_count){
                                                if(mention_iterate_list.childNodes[s].nodeName == "LI"){
                                                    break
                                                }
                                                s++
                                            }
                                            if(i == s){
                                                let mention_type = ''
                                                let active_mention_item = ''
                                                for(let j=max_count-1;j>-1;j--){
                                                    if(mention_iterate_list.childNodes[j].nodeName == "LI"){
                                                        mention_iterate_list.childNodes[j].classList += " "+ 'active'
                                                        active_mention_item = mention_iterate_list.childNodes[j].textContent.trim()
                                                        mention_type = mention_iterate_list.childNodes[j].dataset.type
                                                        if(typeof mention_iterate_list.childNodes[j-2] != 'undefined'){
                                                            CPUtils.scroll( document.querySelector(".iterate-list"), mention_iterate_list.childNodes[j-2].offsetTop)
                                                        }else {
                                                            CPUtils.scroll( document.querySelector(".iterate-list"), mention_iterate_list.childNodes[j].offsetTop)
                                                        }
                                                        break
                                                    }
                                                }
                                                Global.globalValue(VueSignals.KEYBOARD_NAVIGATE_MENTION_ITEM,{
                                                    "mention_item": active_mention_item,
                                                    "mention_id": mention_id,
                                                    "mention_type": mention_type
                                                })
                                                break
                                            }else {
                                                let mention_type = ''
                                                let active_mention_item = ''
                                                for(let j=i-1;j>-1;j--){
                                                    if(mention_iterate_list.childNodes[j].nodeName == "LI"){
                                                        mention_iterate_list.childNodes[j].classList += " "+ 'active'
                                                        active_mention_item = mention_iterate_list.childNodes[j].textContent.trim()
                                                        mention_type = mention_iterate_list.childNodes[j].dataset.type
                                                        if(typeof mention_iterate_list.childNodes[j-2] != 'undefined'){
                                                            CPUtils.scroll( document.querySelector(".iterate-list"), mention_iterate_list.childNodes[j-2].offsetTop)
                                                        }else {
                                                            CPUtils.scroll( document.querySelector(".iterate-list"), mention_iterate_list.childNodes[j].offsetTop)
                                                        }

                                                        break
                                                    }
                                                }
                                                Global.globalValue(VueSignals.KEYBOARD_NAVIGATE_MENTION_ITEM,{
                                                    "mention_item": active_mention_item,
                                                    "mention_id": mention_id,
                                                    "mention_type": mention_type
                                                })
                                                break
                                            }
                                        }
                                    }
                                }
                            }
                            if(e.key == "Escape"){
                                Global.globalValue(VueSignals.KEYBOARD_CLOSE_MESSAGE_LIST, true)
                            }
                        }
                    }
                }
            }
        }
    }

    /** return
     *  Real range where the cursosr is
     */



    static getSpecialKeys(){
        return SpecialKeys
    }
    static getInputArea(){
        return inputArea
    }
    static isNewLineActive(){
        return new_line
    }
    static setListOpen(value){
        isListOpen = value
        if(!value){
            ArrowDowncounter = 0
        }
    }
    static isListOpen(){
        return isListOpen
    }

    static setInputArea(input, is_edit = false){
        if(input != null && input != 'undefined'){
            config.DEFAULT_MESSAGE_AREA_ID = input
            if(is_edit){
                edit_area = true
            }
            inputArea = document.getElementById(config.DEFAULT_MESSAGE_AREA_ID)
        }

        if(inputArea != null){
            KeyboardManager.init(inputArea)
        }else {
            KeyboardManager.init(config.DEFAULT_MESSAGE_AREA_ID)
        }
        // DOMManager.setInputArea(input)
        // TextareaManager.init(inputArea)
    }
    static disableChatMode() {
        chatmode = false
    }

    static enableChatMode() {
        chatmode = true
    }


    static isEnterDown(){
        return EnterDown
    }
    static CheckComination(e){
        /** new line  */
        if(e.code == "Enter" &&  !(e.shiftKey || e.ctrlKey || e.metaKey)){
            e.preventDefault()
            new_line = false
        }

        if(e.code == "Enter" && ( e.shiftKey ||  e.ctrlKey || e.metaKey) && !TextareaManager.isEmptyMessage(inputArea.innerText)){
            new_line = true
            e.stopPropagation()
        }

        if(e.key == 'b' && (e.ctrlKey || e.metaKey)){
            e.preventDefault()
            let container = DOMManager.getCursor().startContainer
            let text = container.textContent
            if(text[text.length-2] != "*"){
                let boldShortCut = document.createTextNode(" \0** \0")
                TextareaManager.AddToCursor(boldShortCut)
                TextareaManager.MoveCursorForStyle("**")

            }else {

            }
        }

        if(e.key == 'i' && (e.ctrlKey || e.metaKey)){
            e.preventDefault()
            let container = DOMManager.getCursor().startContainer
            let text = container.textContent
            if(text[text.length-2] != "_"){
                let boldShortCut = document.createTextNode(" \0__ \0")
                TextareaManager.AddToCursor(boldShortCut)
                TextareaManager.MoveCursorForStyle("__")

            }else {

            }
        }

        if(e.key == 's' && (e.ctrlKey || e.metaKey)){
            e.preventDefault()
            let container = DOMManager.getCursor().startContainer
            let text = container.textContent
            if(text[text.length-2] != "~"){
                let boldShortCut = document.createTextNode(" \0~~ \0")
                TextareaManager.AddToCursor(boldShortCut)
                TextareaManager.MoveCursorForStyle("~~")

            }else {

            }
        }
    }

    /**
     * Blocking past styled data
     */
    static UnstylePaste(){

        let contenteditable = document.querySelector('[contenteditable]')
        contenteditable.addEventListener('paste', function(e){
            // Prevent the default pasting event and stop bubbling
            e.preventDefault()
            e.stopPropagation()
            // Get the clipboard data
            let paste = (e.clipboardData || window.clipboardData).getData('text/plain')

            /** Only for mac osx  upload pic by paste*/
            let items = (e.clipboardData || window.clipboardData).items
            let files = []
            for (let index in items) {
                var item = items[index]
                if (item.kind === 'file') {
                    let blob = item.getAsFile()
                    files.push(blob)
                }
            }
            let activeChannel = SessionManager.getActiveChannel()
            if(!activeChannel.direct && files.length > 0){
                Global.globalValue(VueSignals.UPLOAD_FILE, files)
            }

            /*****/
            // Do something with paste like remove non-UTF-8 characters

            // paste = paste.replace(/\x0D/gi, "\n")
            // paste = paste.replace(/[^\x20-\xFF]/gi, '')
            // Find the cursor location or highlighted area
            const selection = window.getSelection()
            // Cancel the paste operation if the cursor or highlighted area isn't found
            // if (!selection.rangeCount) return false
            // Paste the modified clipboard content where it was intended to go
            // if(selection.getRangeAt(0).collapsed){
            //     // TextareaManager.AddToCursor(document.createTextNode(paste))
            //     if(selection.getRangeAt(0).endContainer.nodeName != "DIV"){
            //         selection.getRangeAt(0).insertNode(document.createTextNode(paste))
            //     }else {
            //         inputArea.childNodes[0].textContent += paste
            //         TextareaManager.MoveCursorAfterAdd(null)
            //         new_line = false
            //     }
            //     selection.getRangeAt(0).collapse(false)
            // }else {
            //     DOMManager.ReplaceNode(DOMManager.getCursor(),document.createTextNode(paste))
            // }
            document.execCommand("insertHTML", false, paste);

            if(this.childNodes.length == 1 && this.childNodes[0].childNodes.length == 0 ){
                this.classList.add('empty')
            }else {
                this.classList.remove('empty')
            }
        })
    }


    static MentionDetector(e){
        if(e.key == '@' && !SessionManager.getActiveChannel().direct){

            Global.globalValue(VueSignals.HIDE_KEYBOARD_FOLDER_LIST, true)

            let cursor = DOMManager.getCursor()
            if(typeof cursor.startContainer.textContent[cursor.startOffset-1] == 'undefined' ||
            (typeof cursor.startContainer.textContent[cursor.startOffset-1] != 'undefined' &&
                cursor.startContainer.textContent[cursor.startOffset-1].trim() == '')){
                Global.globalValue(VueSignals.CREATE_MENTION_USER, true)
                KeyboardManager.setListOpen(true)
            }

            if(typeof cursor.startContainer.textContent[cursor.startOffset-1] != 'undefined' &&
                    cursor.startContainer.textContent[cursor.startOffset-1].trim() == '@'){
                Global.globalValue(VueSignals.HIDE_MENTION_USERS, true)
                KeyboardManager.setListOpen(false)
            }
        }

        if(e.key == '$' && !SessionManager.getActiveChannel().direct){

            Global.globalValue(VueSignals.HIDE_MENTION_USERS, true)

            let cursor = DOMManager.getCursor()
            if(typeof cursor.startContainer.textContent[cursor.startOffset-1] == 'undefined' ||
            (typeof cursor.startContainer.textContent[cursor.startOffset-1] != 'undefined' &&
            cursor.startContainer.textContent[cursor.startOffset-1].trim() == '')){
                Global.globalValue(VueSignals.CREATE_MENTION_FOLDER, true)
                KeyboardManager.setListOpen(true)
            }
        }
    }
}
